export type BulkEditError = {
  status?: number;
  message?: string;
  param?: string;
  id?: number;
};

// A bulk edit 422 names the flag that answers its question (skip_state, skip_user_warehouse,
// skip_serial_number). The API client camelizes response keys; some errors still arrive snake_case.
export function bulkEditError(error: unknown): BulkEditError {
  const response = (error as { response?: { status?: number; data?: { errors?: Record<string, unknown> } } }).response;
  const errors = response?.data?.errors;
  const param = errors?.skipParam ?? errors?.skip_param;
  const rawId = errors?.id;
  return {
    status: response?.status,
    message: typeof errors?.message === "string" ? errors.message : undefined,
    param: typeof param === "string" ? param : undefined,
    id: typeof rawId === "number" || typeof rawId === "string" ? Number(rawId) : undefined,
  };
}
